import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { uploadCaseZips,fetchFileZips } from "../clinical/clinicalThunkApi"
import {
  fetchRefinementJsonFile,
} from "../clinical/refinement/refinementThunkApi"

interface ICacheServiceData {
  /**
   * key is case id, value is a record of zip file name and blob
   */
  caches: Record<string, Record<string, Blob>>
  loading: "idle" | "pending" | "succeeded" | "failed"
}



const defualtState: ICacheServiceData = {
  caches: {},
  loading: "idle",
}
/**
 * this state is used to store the download files from server,if there is a need to download the file again, it will be downloaded from the cache.
 */
export const cacheServiceSlice = createSlice({
  name: "cacheService",
  initialState: {
    ...defualtState
  },
  reducers:{
    clearCache: (state,action) => {
      if (state.caches[action.payload.caseId]) {
        delete state.caches[action.payload.caseId]
        console.log("clearCache ok",state.caches,action.payload.caseId);
      }
    },
    /**
     * Drops the zips cached for every case but caseId: they stay in memory
     * until the tab is closed otherwise (only closeCaseAndClearAllStatus
     * clears the cache), and a tab like the patient list goes through many cases.
     */
    clearOtherCaches: (state, action: PayloadAction<{ caseId: string }>) => {
      for (const cachedCaseId of Object.keys(state.caches)) {
        if (cachedCaseId !== action.payload.caseId) {
          delete state.caches[cachedCaseId]
        }
      }
    },
  },
  extraReducers:(builder) => {
    builder.addCase(uploadCaseZips.pending, (state) => {
      state.loading = "pending"
    })
    builder.addCase(uploadCaseZips.fulfilled, (state, action) => {
      state.loading = "succeeded"
      console.log('uploadaction',action)
      //state.zips = action.payload as Record<string, File>
      const caseId = action.meta.arg.caseId;
      const zips = action.meta.arg.zips;
      if (!state.caches[caseId]) {
        state.caches[caseId] = {} as Record<string, Blob>;
      }
      for (let i = 0; i < zips.length; i++) {
        const zipInfo = zips[i];
        state.caches[caseId][zipInfo.fileName]= zipInfo.file;
      }
    })
    builder.addCase(uploadCaseZips.rejected, (state, action) => {
      state.loading = "failed"
    })
    builder.addCase(fetchFileZips.pending, (state) => {
      state.loading = "pending"
    })
    builder.addCase(fetchFileZips.fulfilled, (state,action) => {
      state.loading = "succeeded"
      const payload = action.payload as any[];
      const files:Record<string,Blob> ={} 
      for (let i = 0; i < payload.length; i++) {
        const item = payload[i];
        const data = item.data;
        const respUrl = item.request.responseURL;
        const fileName = respUrl.split("/").pop();
        files[fileName] = data;
      }
      const caseId = action.meta.arg.caseId;
      //which case to store the zips
      if (!state.caches[caseId]) {
        state.caches[caseId] = {} as Record<string, Blob>;
        state.caches[caseId] = files;
      }
      else {
        for (const key in files) {
          state.caches[caseId][key] = files[key];
        }
      }
    })
    builder.addCase(fetchFileZips.rejected, (state) => {
      state.loading = "failed"
    })
    builder.addCase(fetchRefinementJsonFile.fulfilled, (state, action) => {
      const { payload } = action
      const caseId = action.meta.arg.caseId;
      if (!state.caches[caseId]) {
        state.caches[caseId] = {} as Record<string, Blob>
      }
      state.caches[caseId]["RetouchHistory/RetouchHistory.json"] = payload[0].data 
    })
  }
})

export const {
  clearCache,
  clearOtherCaches,
} = cacheServiceSlice.actions